module.exports = __webpack_public_path__ + "img/formsTrapezSOR.b30220c3.svg";